import {
	ClientPortfolioDomainEnum,
	GoalStateEnum,
} from "web_myplann/Infrastructure/Api/Api";

// TODO(Maros): Will probably be pulled from API
export const GOAL_REAL_YIELD = 0.04;

export const ALLOCATION_MIN = 5;
export const ALLOCATION_MAX = 100;
export const ALLOCATION_STEP = 5;

export const LOAN_RATE_MIN = 2;
export const LOAN_RATE_MAX = 8;
export const LOAN_RATE_STEP = 0.1;
export const LOAN_RATE_DEFAULT = 5.2;
export const LOAN_TERM_STEP = 1;

export const EXTRA_CONTRIBUTION_PRESETS = [500, 1_000, 2_000, 5_000];
export const EXTRA_CONTRIBUTION_DEFAULT = 1_000;
export const EXTRA_CONTRIBUTION_MAX = 10_000;
export const EXTRA_CONTRIBUTION_STEP = 100;
export const EXTRA_CONTRIBUTION_PROGRESS_MIN = 5;
export const EXTRA_CONTRIBUTION_PROGRESS_MAX = 95;

export const SAVINGS_DELAY_MONTHS = 12;
export const SAVINGS_DELAY_MIN_MONTHS = 6;

export const GOAL_NAME_MAX_LENGTH = 100;
export const GOAL_AMOUNT_MAX = 999_999_999;
export const GOAL_MONTHLY_RENT_MAX = 999_999;
export const GOAL_RENT_YEARS_MIN = 1;
export const GOAL_RENT_YEARS_MAX = 100;
export const GOAL_DEADLINE_MAX_YEARS = 60;

export const FUTURE_CONTRACT_NAME_MAX_LENGTH = 100;
export const FUTURE_CONTRACT_NOTE_MAX_LENGTH = 1_000;
export const FUTURE_CONTRACT_LUMP_SUM_MAX = 999_999_999;
export const FUTURE_CONTRACT_MONTHLY_MAX = 999_999;
export const FUTURE_CONTRACT_START_MAX_YEARS = 60;

export const ACTIVE_GOAL_STATES = [GoalStateEnum.Created, GoalStateEnum.Active];

export const NEW_CONTRACT_NAME_MIN_LENGTH = 2;

export const NEW_CONTRACT_TYPES = [
	ClientPortfolioDomainEnum.BankingProducts,
	ClientPortfolioDomainEnum.BuildingSavings,
	ClientPortfolioDomainEnum.Investments,
	ClientPortfolioDomainEnum.PensionProducts,
] as const;
